import { render, staticRenderFns } from "./ConsumationServices.vue?vue&type=template&id=2a77ba32"
import script from "./ConsumationServices.vue?vue&type=script&lang=js"
export * from "./ConsumationServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports